import {GetBannerRequest_PriorityOverride} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/banner/service.types';
import {useQueryParams} from '@aboutyou/router';
import {useMemo} from 'react';
import {
  DISABLE_HEADER_HIGHLIGHT_PARAM,
  HEADER_HIGHLIGHT_OVERRIDE_PARAM,
  mapDisableHeaderHighlight,
  mapHeaderHighlightOverride,
} from './headerHighlightParams';

export interface HeaderHighlightParams {
  disableHeaderHighlight: boolean;
  priorityOverride: GetBannerRequest_PriorityOverride | undefined;
}

/**
 * Reads the Header Highlight link-param overrides from the current URL:
 * - `?disableHeaderHighlight=true` suppresses the banner on that page.
 * - `?headerHighlightOverride=<type>` bumps that banner type to prio 1.
 *
 * Both values are matched case-insensitively. The URL is read via
 * `useQueryParams`, so the values update on SPA navigation. The result is
 * memoized on the two raw param strings, so it stays referentially stable
 * across re-renders and changes of unrelated params (filters, sorting).
 */
export const useHeaderHighlightParams = (): HeaderHighlightParams => {
  const queryParams = useQueryParams();

  const disableParam = queryParams.get(DISABLE_HEADER_HIGHLIGHT_PARAM);
  const overrideParam = queryParams.get(HEADER_HIGHLIGHT_OVERRIDE_PARAM);

  return useMemo(
    () => ({
      disableHeaderHighlight: mapDisableHeaderHighlight(disableParam),
      priorityOverride: mapHeaderHighlightOverride(overrideParam),
    }),
    [disableParam, overrideParam],
  );
};
